import UdeskLocales from 'UdeskLocales';
import React, { FC } from 'react';
import { Tabs } from 'udesk-ui';

interface TemplateProps {
    taskType: string;
    onTaskTypeChange: (type: string) => void;
    showCollection: boolean;
}

const Template: FC<TemplateProps> = (props) => {
    const { taskType, onTaskTypeChange, showCollection } = props;
    const locales = UdeskLocales['current'];

    return (
        <Tabs activeKey={`${taskType}`} size="small" onChange={onTaskTypeChange}>
            <Tabs.TabPane tab={locales.fix.qualityInspectionTemplate} key="1"></Tabs.TabPane>

            {showCollection && (
                <Tabs.TabPane tab={locales.fix.collectionTemplate} key="2"></Tabs.TabPane>
            )}
        </Tabs>
    );
};

export default Template;
